@let options = props.options | formlySelectOptions: field | async;

@if (props.readonly) {
  <new-ui-wrapper-readonly [label]="props.label">
    <ng-template #value>
      {{ getValueLabel(options, formControl.value) }}

      @if (additionalInformation && additionalInformation.formControl.value && !additionalInformation.hide) {
        ({{ additionalInformation.formControl.value }})
      }
    </ng-template>
  </new-ui-wrapper-readonly>
} @else {
  <div class="col">
    <div class="flex items-center">
      <new-ui-dropdown
        [dt]="props.dt"
        class="flex-1 min-w-px"
        [formControl]="$any(formControl)"
        [formlyAttributes]="field"
        [options]="options"
        optionValue="value"
        optionLabel="label"
        [label]="shortLabel"
        [showClear]="true"
        [required]="props.required"
        [readonly]="props.readonly"
      />

      @if (!props.readonly && (props.tooltip || isShortLabel)) {
        <new-ui-button
          [dt]="props.dt?.components?.button"
          icon="pi pi-question-circle"
          severity="secondary"
          variant="text"
          class="max-mobile:hidden"
          [pTooltip]="tooltipContent"
        />
        <ng-template #tooltipContent>
          <div class="col gap-4">
            <span class="text-header">{{ props.label }}</span>
            <ul class="">
              <li>
                <span class="text-text-caption">{{ props.tooltip }}</span>
              </li>
            </ul>
          </div>
        </ng-template>

        <new-ui-button
          [dt]="props.dt?.components?.button"
          icon="pi pi-question-circle"
          severity="secondary"
          variant="text"
          class="min-mobile:hidden"
          (onClick)="tooltipMobile.show($event)"
        />

        <p-popover [dt]="props.dt?.components?.popover" #tooltipMobile>
          <ng-template #content>
            <div class="col gap-4">
              <span class="text-header">{{ props.label }}</span>
              <ul class="">
                <li>
                  <span class="text-text-caption">{{ props.tooltip }}</span>
                </li>
              </ul>
            </div>
          </ng-template>
        </p-popover>
      }

      @if (additionalInformation && !additionalInformation.hide) {
        <div>
          <new-ui-button
            [dt]="props.dt?.components?.button"
            icon="icon-[mi--dots]"
            severity="secondary"
            variant="text"
            (onClick)="addInfoOverlay.show($event)"
          />

          <p-popover [dt]="props.dt?.components?.popover" #addInfoOverlay>
            <ng-template #content>
              <new-ui-inputtext
                [formControl]="$any(additionalInformation.formControl)"
                [label]="additionalInformation.props.label"
                [readonly]="props.readonly"
              />
            </ng-template>
          </p-popover>
        </div>
      }
    </div>

    @if (showError) {
      <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
        <formly-validation-message [field]="field" />
      </p-message>
    }
  </div>
}
